export default __webpack_public_path__ + "static/media/ship-arrival.f9f2e347.png";